
export class PasswordRequestDto {
  password: string;
}
